import { useConfig } from "@/contexts/cdpConfig";
import { getFeaturesEnabled } from "@/utils";
export const useIsPreviewMode = () => {
    const { previewMode } = getFeaturesEnabled();
    const previewModeFromConfig = useConfig().previewMode;
    return previewMode || previewModeFromConfig;
};
